import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/app/urunler/[categorySlug]/[slug]/ProductPageClient.tsx");
